import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { preloadPageCss } from './hooks/usePageCss'
import { initLogRocket } from './config/logrocket'
import './index.css'

initLogRocket()
preloadPageCss()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
